import React, { useState } from "react";
import loginBackgroundImage from "../../../images/login_background_image.png";
import kpitLogo from "../../../images/kpit_logo_new.png";
import { Alert } from "react-bootstrap";
import { connect } from "react-redux";
import Link from "@material-ui/core/Link";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { loginUser } from "../../../actions/auth/authAction";
import Usercard from "./userBox/Card";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  gappingInLogin: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: "25px",
    margin: "25px",
  },
  gapping: { padding: "25px", margin: "25px" },
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  cssMerger: {
    position: "relative",
    left: "calc(100% - 150px)",
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
const Login = (props) => {
  const classes = useStyles();
  const [error, setError] = useState(null);
  const [loader,setLoader]=useState(false)
  const ksilSetup = async (landingPage) => {
    try {
      setLoader(true)
      const response = await axios.get("/api/user/details");
      localStorage.setItem("userDetails", JSON.stringify(response.data));
      setLoader(false)
      props.history.push(landingPage);
    } catch (error) {
      if (error.response.data && error.response.data && error.response.data.message)
        setError(error.response.data.message);
       setLoader(false)
    }
  };

  return (
    <>
      <div
        style={{ display: "flex", backgroundColor: "white", minHeight: "100%" }}
      >
        <Box
          sx={{
            padding: "0px",
            overflow: "hidden",
            width: "50%",
            backgroundImage:`url("${loginBackgroundImage}")`,
            backgroundRepeat: "no-repeat",
            backgroundSize:"cover"
          }}
        >
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "0px",
            overflow: "hidden",
            width: "50%",
          }}
        >
          <Box sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
            <Box className={classes.gapping}>
              <Box sx={{ width: "150px" }} className={classes.cssMerger}>
                <img src={kpitLogo} alt="" style={{ width: "100%" }}></img>
              </Box>
            </Box>
            <Box className={classes.gappingInLogin}>
              <div style={{ height: "120px" }}>
                <div>
                  {(error || props.error) && (
                    <Alert variant="danger">
                      <Alert.Heading>Got an error!</Alert.Heading>
                      {props.error && <p>{props.error}</p>}
                      {error && <p>{error}</p>}
                    </Alert>
                  )}
                </div>
              </div>
              <Usercard
                loginUser={props.loginUser}
                loader={props.loading || loader}
                initalLoader={ksilSetup}
              />
            </Box>
          </Box>
        </Box>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loginUser.loading,
  error: state.loginUser.error,
});

const mapDispatchToProps = (dispatch) => ({
  loginUser: (initalLoader, payload, landingPage) =>
    dispatch(loginUser(initalLoader, payload, landingPage)),
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
